import React, { useEffect, useRef, useState } from 'react';

const DEFAULT_CHART_WIDTH = 280;
const Y_AXIS_GUTTER = 48;
const MIN_SLOT_WIDTH = 32;

export const getTickSlotWidth = (chartWidth, barCount) => {
  const innerWidth = Math.max((chartWidth || DEFAULT_CHART_WIDTH) - Y_AXIS_GUTTER, MIN_SLOT_WIDTH);
  return Math.max(MIN_SLOT_WIDTH, (innerWidth / Math.max(barCount, 1)) - 6);
};

export const createWrappedBarChartXAxisTick = ({ barCount, chartWidth = DEFAULT_CHART_WIDTH }) => {
  const slotWidth = getTickSlotWidth(chartWidth, barCount);

  const WrappedBarChartXAxisTick = ({ x, y, payload }) => {
    const label = payload?.value ?? '';
    const foreignObjectX = x - slotWidth / 2;

    return (
      <foreignObject
        x={foreignObjectX}
        y={y + 2}
        width={slotWidth}
        height={44}
        className="overflow-visible"
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          className="text-[11px] leading-tight text-center text-slate-500 break-words line-clamp-3"
          title={label}
        >
          {label}
        </div>
      </foreignObject>
    );
  };

  WrappedBarChartXAxisTick.displayName = 'WrappedBarChartXAxisTick';
  return WrappedBarChartXAxisTick;
};

export const getWrappedBarChartXAxisProps = ({ barCount, chartWidth = DEFAULT_CHART_WIDTH }) => ({
  dataKey: 'name',
  interval: 0,
  height: 52,
  tickLine: false,
  tick: createWrappedBarChartXAxisTick({ barCount, chartWidth })
});

export const REVENUE_BAR_CHART_MARGIN = { top: 4, right: 8, left: 0, bottom: 0 };

export const useContainerWidth = () => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const updateWidth = () => {
      setWidth(node.getBoundingClientRect().width || 0);
    };

    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};
